

export const pathLastSegment = s => s.substring(s.lastIndexOf('/') + 1);

export function capitalizeString(str){
    if(!str) return '';
    const firstLetter = str.charAt(0);
    const restOfStr = str.replace(str.charAt(0), "").toLowerCase();
    return firstLetter + restOfStr;
  }

export const pathSecondLastSegnment = path => {
  let last = path.substring(0, path.lastIndexOf('/'));
  return pathLastSegment(last);
}

export function buildList(list) {
  let result = '';
  let item;

  for (item of list) {
    if (item.length) {
      if (result.length) {
        result = result.concat(", ").concat(item);
      } else {
        result = result.concat(item);
      }
    }
  }
  return result;
}

export function camelCaseAttr(str) {
  if(!str) return '';

  return str.split('.').map(function(word) {
    const firstLetter = word.charAt(0).toLowerCase();
    return firstLetter + word.substring(1);
  }).join('.');
}